import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
import { Link } from "react-router-dom";
import { useAPI } from "../contexts/APIContext";

export default function LandingPage() {
  const { user } = useAPI();
  const isAuthenticated = !!user;

  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-800">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="flex flex-row flex-1 text-center justify-center gap-16 items-center px-6 py-20 sm:py-32">
        <h1 className="text-xl sm:text-2xl font-semibold text-primary mb-4 max-w-96">
          Connect with real people and start speaking immediately.
        </h1>
        {isAuthenticated ? (
          <Link
            to="/dashboard"
            className="bg-primary hover:bg-primary-light text-white py-3 px-6 rounded-full transition"
          >
            Go to Dashboard
          </Link>
        ) : (
          <Link
            to="/dashboard"
            className="bg-primary hover:bg-primary-light text-white py-3 px-6 rounded-full transition"
          >
            Start Now
          </Link>
        )}
      </section>

      {/* Features Section */}
      <section id="features" className="px-6 py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 text-center shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              <span className="mr-2">🌟</span>Active Community
            </h3>
            <p className="text-gray-600">Always-on learners and natives ready to chat.</p>
          </div>
          <div className="bg-white rounded-2xl p-8 text-center shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              <span className="mr-2">📅</span>Easy Scheduling
            </h3>
            <p className="text-gray-600">Set your availability and let others book chats or calls.</p>
          </div>
          <div className="bg-white rounded-2xl p-8 text-center shadow hover:shadow-lg transition">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              <span className="mr-2">⚡</span>Engaging Conversations
            </h3>
            <p className="text-gray-600">We give you things to talk about so you never run out of things to say.</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="px-6 py-12 max-w-xl mx-auto space-y-4">
        <blockquote className="bg-blue-100 p-6 rounded-2xl italic text-gray-600">
          "Within a week of joining Pimaru, I found a Japanese friend to practice with regularly. Our conversations have
          become the highlight of my day." — Leo, São Paulo, Brazil
        </blockquote>
        <blockquote className="bg-blue-100 p-6 rounded-2xl italic text-gray-600">
          "I can hop into a conversation any time—it's like having a language partner in my pocket." — Nina, Berlin,
          Germany
        </blockquote>
        <blockquote className="bg-blue-100 p-6 rounded-2xl italic text-gray-600">
          "The mix of casual and guided chats keeps me motivated. I've never enjoyed language practice more!" — Ahmed,
          Cairo, Egypt
        </blockquote>
      </section>

      {/* CTA Section */}
      <section id="signup" className="text-center px-6 py-12">
        {isAuthenticated ? (
          <Link
            to="/dashboard"
            className="bg-primary hover:bg-primary-light text-white py-3 px-6 rounded-full transition"
          >
            Return to Dashboard
          </Link>
        ) : (
          <Link to="/login" className="bg-primary hover:bg-primary-light text-white py-3 px-6 rounded-full transition">
            Join Pimaru
          </Link>
        )}
      </section>

      <Footer />
    </div>
  );
}
